import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/base.component';
import { TenantUIService } from '../tenant-ui.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { PermissionDictionary/*, RequiredPermissions*/, UserPermissionService } from 'src/app/services/user/user-permission.service';

@AutoUnsubscribe({ arrayName: 'subscriptions' })
// @RequiredPermissions([PermissionDictionary.Tenant_SettingsEditor])
@Component({
    selector: 'app-current-tenant',
    templateUrl: './current-tenant.component.html',
    styleUrls: ['./current-tenant.component.scss']
})
export class CurrentTenantComponent extends BaseComponent implements OnInit {

    PermissionDictionary = PermissionDictionary;

    constructor(
        public service: TenantUIService,
        private router: Router,
        private route: ActivatedRoute,
        public userPermissionService: UserPermissionService
    ) {
        super();
        this.userPermissionService.registerPermissions([PermissionDictionary.Tenant_SettingsEditor]);
    }

    ngOnInit(): void {
        this.subscriptions.push(this.route.paramMap.subscribe(params => {
            const tenantName = params.get('name');
            if (tenantName) {
                this.service.setTenantName(tenantName);
            }
            // }
        }));

    }
}
